var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReseller(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 90,
    viewBox: "0 0 98 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3758 62.9572L20.082 68.877L24.8392 72.9166C27.4003 75.0914 29.5688 77.686 31.2513 80.5887L31.5607 81.1226C33.1994 83.9498 36.8322 84.9166 39.6749 83.2819C42.5174 81.6472 43.4934 78.0301 41.8546 75.2027L41.5451 74.6689C39.8627 71.7662 37.6942 69.1716 35.1331 66.9968L30.3758 62.9572Z",
    fill: "url(#paint0_linear_4:11928)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9797 72.4269C30.9358 74.088 32.5919 76.0699 33.8769 78.287L34.1383 78.7379C34.8 79.8797 36.2673 80.2701 37.4152 79.6099C38.5632 78.9498 38.9573 77.4888 38.2955 76.347L38.0342 75.8961C36.7492 73.6791 35.0929 71.6972 33.137 70.036L31.6781 69.0306C31.081 68.6191 30.2985 68.5875 29.6688 68.9496L29.1121 69.2698C27.918 69.9567 27.847 71.6464 28.9797 72.4269Z",
    fill: "url(#paint1_linear_4:11928)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3772 62.9574L20.082 68.8779L20.4369 69.1792L41.6347 74.8202L41.5482 74.6709C39.8655 71.7679 37.6967 69.173 35.1353 66.9979L30.3772 62.9574Z",
    fill: "url(#paint2_linear_4:11928)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6289 66.6523L9.84866 56.6801C8.42428 54.2227 9.27242 51.0787 11.7433 49.6577L25.8441 41.5486C28.3148 40.1278 31.4725 40.9679 32.897 43.4255L38.6772 53.3977C40.1016 55.8551 39.2534 58.9991 36.7826 60.4201L22.6817 68.5292C20.2109 69.9501 17.0533 69.1098 15.6289 66.6523Z",
    fill: "url(#paint3_linear_4:11928)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5025 57.3589C56.3237 58.1345 45.228 59.5505 34.21 61.6262C32.7226 61.9065 31.2213 61.222 30.4654 59.9179L23.117 47.2402C22.3611 45.936 22.5169 44.2986 23.504 43.1558C30.818 34.6894 37.5969 25.8261 43.8605 16.5708C45.2319 14.5445 48.1959 14.4584 49.6696 16.4083C58.0969 27.5584 65.0677 39.585 70.5484 52.4292C71.5069 54.6754 69.9497 57.189 67.5025 57.3589Z",
    fill: "url(#paint4_linear_4:11928)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7742 54.4434L24.3984 42.1022C24.0986 42.4527 23.7994 42.8035 23.4977 43.1526C22.5102 44.2957 22.3547 45.9331 23.1107 47.2374L30.4598 59.9164C31.2158 61.2207 32.7175 61.9051 34.2048 61.6249C45.2241 59.5488 56.3209 58.1326 67.5008 57.3571C69.2167 57.238 70.4934 55.9666 70.7742 54.4434Z",
    fill: "url(#paint5_linear_4:11928)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7076 14.7529C47.4779 13.145 45.0223 13.2181 43.8801 14.8915C43.1501 15.9608 43.2687 17.364 44.1057 18.3503C44.1519 18.4048 44.1971 18.461 44.2408 18.5189C53.0203 30.1379 60.2825 42.6701 65.9922 56.0545C66.0207 56.1213 66.0469 56.1883 66.0711 56.2552C66.5099 57.4707 67.6704 58.2747 68.9648 58.1794C70.9905 58.0305 72.2819 55.948 71.499 54.0833C65.5941 40.0159 57.9834 26.8822 48.7076 14.7529Z",
    fill: "url(#paint6_linear_4:11928)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8927 64.1414C32.3065 65.0538 30.2794 64.5142 29.3649 62.9363L19.9477 46.687C19.0333 45.1091 19.5778 43.0905 21.164 42.1782C22.7502 41.2659 24.7773 41.8054 25.6918 43.3833L35.109 59.6326C36.0237 61.2103 35.4789 63.2291 33.8927 64.1414Z",
    fill: "url(#paint7_linear_4:11928)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.773 39.1255C68.6502 39.1961 68.5201 39.2571 68.3826 39.3075C67.0848 39.7834 65.6465 39.1224 65.1702 37.8311C64.7531 36.7008 64.2438 35.5409 63.656 34.3834C62.5083 32.123 61.1409 30.0512 59.8058 28.5495C58.8902 27.5196 58.9876 25.9449 60.0234 25.0322C61.0602 24.1196 62.6412 24.2145 63.5569 25.2444C65.1906 27.0819 66.77 29.4631 68.1246 32.1309C68.7993 33.4594 69.3865 34.7975 69.8698 36.1078C70.2958 37.2624 69.8085 38.5299 68.773 39.1255ZM76.1607 38.8875C75.9038 39.0353 75.6163 39.1398 75.306 39.1896C73.9409 39.4088 72.6571 38.4851 72.4387 37.1266C71.9584 34.1388 70.862 30.9007 69.268 27.7617C67.6752 24.6251 65.7167 21.8458 63.6046 19.7238C62.6321 18.747 62.6402 17.1693 63.623 16.2002C64.6049 15.2308 66.1905 15.2372 67.163 16.214C69.6383 18.7003 71.9115 21.9148 73.7367 25.5093C75.5607 29.1011 76.8214 32.8439 77.3824 36.333C77.5512 37.3827 77.0343 38.3851 76.1607 38.8875ZM84.6546 39.934C84.2993 40.1384 83.8888 40.2584 83.4496 40.2667C82.0674 40.2923 80.9273 39.1979 80.9033 37.8221C80.826 33.4012 79.5811 28.6933 77.3031 24.2072C75.0279 19.7267 71.9811 15.9775 68.4925 13.3649C67.3884 12.5381 67.1679 10.9762 67.9999 9.87621C68.8321 8.77634 70.4015 8.55484 71.5055 9.38151C75.6029 12.4497 79.153 16.7975 81.7716 21.9549C84.3879 27.1069 85.8183 32.5615 85.9089 37.7291C85.9253 38.6679 85.4177 39.4952 84.6546 39.934Z",
    fill: "#FFC107"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4:11928",
    x1: 29.3556,
    y1: 76.3806,
    x2: 42.3856,
    y2: 68.8281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4:11928",
    x1: 35.2577,
    y1: 73.2937,
    x2: 29.0132,
    y2: 76.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4:11928",
    x1: 39.2086,
    y1: 69.9204,
    x2: 9.40442,
    y2: 61.9821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE3F45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4:11928",
    x1: 23.0075,
    y1: 52.8735,
    x2: 28.4234,
    y2: 62.2911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD985D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED5B39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4:11928",
    x1: 41.2472,
    y1: 38.9284,
    x2: 53.1342,
    y2: 59.5985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD985D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED5B39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4:11928",
    x1: 42.9447,
    y1: 55.3284,
    x2: -15.1163,
    y2: 39.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE3F45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4:11928",
    x1: 57.7256,
    y1: 34.7293,
    x2: 64.5019,
    y2: 40.3259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4:11928",
    x1: 27.2321,
    y1: 52.8004,
    x2: 30.8364,
    y2: 54.5494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })))));
}

export default SvgReseller;